<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Component</div>
        </h4>
        <div
          class="close-properties"
          @click="$emit('close-configuration')"
        >
          &times;
        </div>
        <div class="wrap-type">
          <img :src="require(`@/assets/new-form-ui/field-icon/${iconComponent}.svg`)">
          <div class="text-type">{{ dataComponent.name.replace(/_/g, ' ') }}</div>
        </div>
      </div>

      <!-- Form UI & Multiple Form UI -->
      <j-exp-manager-form
        v-if="componentType === 'form_ui' || componentType === 'multiple_form_ui'"
        ref="componentFormRef"
        :data-master="dataMaster"
        :data-component="dataComponent"
        :data-edit="dataEdit"
        :pages-id="pagesId"
        :is-multiple="componentType === 'multiple_form_ui'"
      />
      <!-- Canvas Form -->
      <j-canvas-form
        v-if="componentType === 'canvas'"
        ref="componentFormRef"
        :data-master="dataMaster"
        :data-component="dataComponent"
        :data-edit="dataEdit"
        :pages-id="pagesId"
      />
      <!-- HTML Form -->
      <j-html-form
        v-if="componentType === 'html'"
        ref="componentFormRef"
        :data-master="dataMaster"
        :data-component="dataComponent"
        :data-edit="dataEdit"
        :pages-id="pagesId"
      />
      <!-- Embed URL Form -->
      <j-embed-url-form
        v-if="componentType === 'embed_url'"
        ref="componentFormRef"
        :data-master="dataMaster"
        :data-component="dataComponent"
        :data-edit="dataEdit"
        :pages-id="pagesId"
      />
      <!-- Component Form -->
      <j-component-form
        v-if="
          componentType.includes('attendance') ||
            componentType.includes('leave') ||
            componentType.includes('overtime') ||
            componentType.includes('timesheet') ||
            componentType === 'hierarchy' ||
            componentType === 'custom_hierarchy' ||
            componentType === 'user_setup' ||
            componentType === 'employee_setup' ||
            componentType === 'access_management'
        "
        ref="componentFormRef"
        :data-master="dataMaster"
        :data-component="dataComponent"
        :data-edit="dataEdit"
        :pages-id="pagesId"
      />

      <!-- Configuration Button -->
      <div
        :class="{'justify-content-end': !dataEdit}"
        class="properties-field-button"
      >
        <button
          v-if="dataEdit"
          class="button-border"
          @click="$emit('delete-component')"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="$emit('close-configuration')"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="applyComponent"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// Components
import jExpManagerForm from '@/views/application-manager/detail/app-tabs/forms/jExpManagerForm';
import jCanvasForm from '@/views/application-manager/detail/app-tabs/forms/jCanvasForm';
import jHtmlForm from '@/views/application-manager/detail/app-tabs/forms/jHtmlForm';
import jEmbedUrlForm from '@/views/application-manager/detail/app-tabs/forms/jEmbedUrlForm';
import jComponentForm from '@/views/application-manager/detail/app-tabs/forms/jComponentForm';

export default {
  components: {
    jExpManagerForm,
    jCanvasForm,
    jHtmlForm,
    jEmbedUrlForm,
    jComponentForm,
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    dataMaster: {
      type: Object,
      default: () => null,
    },
    dataComponent: {
      type: Object,
      default: () => null,
    },
    dataEdit: {
      type: Object,
      default: () => null,
    },
    pagesId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {};
  },

  computed: {
    componentType() {
      return this.dataComponent.component_type || this.dataComponent.type;
    },

    iconComponent() {
      if (this.componentType === 'form_ui') return 'single_experience_manager';
      else if (this.componentType === 'multiple_form_ui') return 'multiple_experience_manager';
      else if (this.componentType === 'canvas') return 'canvas';
      return 'canvas';
    },
  },

  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm']),

    applyComponent() {
      if (!this.dataEdit) {
        const dataParam = {
          data: this.$refs.componentFormRef.getData(),
          id: this.dataMaster.id,
        };
        if (dataParam.data) {
          this.saveComponent(dataParam).then((res) => {
            if (!res.error) {
              this.$emit('close-configuration');
              this.$emit('refresh-component');
            }
          });
        }
      } else {
        const dataParam = {
          data: this.$refs.componentFormRef.getData(),
          id: this.dataMaster.id,
          component_id: this.dataEdit.id,
        };
        if (dataParam.data) {
          this.updateComponent(dataParam).then((res) => {
            if (!res.error) {
              this.$emit('close-configuration');
              this.$emit('refresh-component');
            }
          });
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/jComponentProperties.vue